/* eslint-disable import/prefer-default-export */
export const SET_ACCOUNT_ID_PARAM = 'SET_ACCOUNT_ID_PARAM'
